<div class="container-fluid mt-4">
  <div class="grid">
    <div class="col-12">
      <h1>Job Integrations</h1>
      <p class="text-secondary">
        Manage third-party integrations for sending sensor data to external companies.
      </p>
    </div>

    <!-- Active Job Integrations Section -->
    <div class="col-12 mt-4">
      <p-card>
        <ng-template #header>
          <div class="flex justify-content-between align-items-center p-3">
            <h2 class="m-0">Active Job Integrations</h2>
            <p-button 
              icon="pi pi-refresh" 
              label="Refresh" 
              (onClick)="refreshData()"
              class="p-button-sm p-button-outlined">
            </p-button>
          </div>
        </ng-template>

        <p-table 
          [value]="(activeIntegrations$ | async) ?? []" 
          [loading]="loading()"
          [paginator]="true" 
          [rows]="10"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} integrations"
          class="p-datatable-striped">
          
          <ng-template #header>
            <tr>
              <th>Job Name</th>
              <th>Integration Type</th>
              <th>Status</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </ng-template>

          <ng-template #body let-integration>
            <tr>
              <td>{{ integration.jobName }}</td>
              <td>{{ integration.integrationType }}</td>
              <td>
                <p-tag 
                  [value]="integration.status" 
                  [severity]="integration.status === 'Active' ? 'success' : 'warn'">
                </p-tag>
              </td>
              <td>{{ integration.created | date:'short' }}</td>
              <td>
                <p-button 
                  icon="pi pi-trash" 
                  class="p-button-sm p-button-rounded p-button-text p-button-danger"
                  pTooltip="Delete Integration"
                  (onClick)="onDeleteIntegration(integration)">
                </p-button>
              </td>
            </tr>
          </ng-template>

          <ng-template #emptymessage>
            <tr>
              <td colspan="5" class="text-center p-4">
                <i class="pi pi-info-circle" style="font-size: 2rem; color: var(--text-color-secondary);"></i>
                <p class="mt-2 text-secondary">No active integrations found.</p>
                <p class="text-secondary">Create integrations from the active jobs list below.</p>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>

    <!-- Non-Integrated Active Jobs Section -->
    <div class="col-12 mt-4">
      <p-card>
        <ng-template #header>
          <div class="p-3">
            <h2 class="m-0">Active Jobs Without Integrations</h2>
            <p class="text-secondary m-0 mt-2">
              Jobs started within the last month that do not have an end date and are not yet integrated.
            </p>
          </div>
        </ng-template>

        <p-table 
          [value]="(nonIntegratedJobs$ | async) ?? []" 
          [paginator]="true" 
          [rows]="10"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} jobs"
          class="p-datatable-striped">
          
          <ng-template #header>
            <tr>
              <th>Job Name</th>
              <th>Start Date</th>
              <th>Actions</th>
            </tr>
          </ng-template>

          <ng-template #body let-job>
            <tr>
              <td>{{ job.name }}</td>
              <td>{{ job.startTime | date:'short' }}</td>
              <td>
                <p-button 
                  icon="pi pi-plus" 
                  label="Create Integration"
                  class="p-button-sm"
                  (onClick)="onCreateIntegration(job)">
                </p-button>
              </td>
            </tr>
          </ng-template>

          <ng-template #emptymessage>
            <tr>
              <td colspan="3" class="text-center p-4">
                <i class="pi pi-check-circle" style="font-size: 2rem; color: var(--p-green-500, #22c55e);"></i>
                <p class="mt-2 text-secondary">All active jobs have integrations configured.</p>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>

  </div>
</div>

<!-- Create Integration Dialog -->
<p-dialog 
  [(visible)]="displayCreateDialog" 
  [modal]="true" 
  [style]="{width: '450px'}" 
  header="Create Integration"
  [draggable]="false" 
  [resizable]="false">
  
  <div class="p-fluid">
    <div class="field">
      <label>Job</label>
      <input type="text" pInputText [value]="selectedJob()?.name" disabled />
    </div>
    
    <div class="field">
      <label for="integrationCompany">Integration Company</label>
      <p-select 
        [ngModel]="selectedIntegrationCompany()"
        (ngModelChange)="selectedIntegrationCompany.set($event)"
        [options]="availableCompanies"
        placeholder="Select Company"
        inputId="integrationCompany">
      </p-select>
    </div>
  </div>
  
  <ng-template #footer>
    <p-button 
      label="Cancel" 
      icon="pi pi-times" 
      class="p-button-text"
      (onClick)="cancelCreateIntegration()">
    </p-button>
    <p-button 
      label="OK" 
      icon="pi pi-check" 
      (onClick)="confirmCreateIntegration()">
    </p-button>
  </ng-template>
</p-dialog>
